<template>
  <div class="product-images">
    <div v-if="images.length === 0">
      <add-image ref="imageCropper" @create-image-data="addImageFromUploader"> </add-image>
    </div>
    <draggable :list="images" draggable=".draggable-node">
      <div v-for="(image, index) in images" :key="'product_image_' + index" class="draggable-node relative">
        <div v-if="image.status === 'PENDING'" class="loading-overlay">
          <!-- <div class="loading-overlay"> -->
          <loader-static :size="'50px'" :light="true" class="centered"></loader-static>
        </div>
        <img
          class="thumbnailImage"
          :src="image.src"
          @click="$refs.imageCropper.displayEditorWithExistingImage(image, index)"
        />
        <div class="product-actions">
          <button
            v-if="image.id"
            class="removeButton"
            data-test-id="product_gallery_remove"
            style=""
            @click="removeImage(index, image.id)"
          >
            <img src="@/assets/img/productBuilding/delete-icon.svg" alt="" />
          </button>
        </div>
      </div>
      <div v-if="images.length" slot="footer" role="group" aria-label="Basic example" key="footer">
        <add-image ref="imageCropper" @create-image-data="addImageFromUploader"> </add-image>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import AddImage from "@/components/shared/addImage/addImage.vue";
import { ImageService } from "../../../../../services/image.service";
import ImageApi from "../../../../../services/api/imageApi";

export default {
  components: {
    draggable,
    AddImage,
  },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    imageIdsForDelete: {
      type: Array,
      default: () => [],
    },
    productId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    addImageFromUploader,
    removeImage,
    uploadImage,
    updateImage,
    processImage,
  },
};

function removeImage(index, imageId) {
  // only allow removal of images if it is not the last image

  if (this.images.length > 1) {
    ImageApi.deleteImage(imageId).then(() => {
      this.images.splice(index, 1);
    });
  } else {
    this.$swal(
      "Attention",
      "Products must have at least one image. Please upload another if you wish to remove this one."
    );
  }
}

function addImageFromUploader(imageData) {
  const imagesForProcessing = [];
  if (Array.isArray(imageData)) {
    imageData.forEach((image) => {
      imagesForProcessing.push(image);
    });
  } else {
    imagesForProcessing.push(imageData);
  }

  imagesForProcessing.forEach((image) => {
    this.processImage(image);
  });
}

function processImage(imageData) {
  const index = imageData.index;

  if (index != null) {
    delete imageData["index"];
  }

  if (imageData.src) {
    if (index != null) {
      this.$set(this.images, index, {
        ...this.images[index],
        ...imageData,
      });
    } else {
      this.images.push(imageData);
    }
  } else {
    this.images.push(...imageData);
  }
  if (imageData.id) {
    // if this image already exists in the db, update it.
    imageData.status = "PENDING";
    this.updateImage(imageData).then((newImage) => {
      newImage.originalSrc = newImage.original_url;
      newImage.cropParams = newImage.crop_params;
      const index = this.images.map((image) => image.id).indexOf(newImage.id);
      this.images.splice(index, 1, newImage);
    });
  } else {
    // if this image is new, upload it.
    imageData.status = "PENDING";
    this.uploadImage(imageData)
      .then((newImage) => {
        newImage.originalSrc = newImage.original_url;
        newImage.cropParams = newImage.crop_params;
        // replace the original image with a new image returned from the server
        const index = this.images.indexOf(imageData);
        this.images.splice(index, 1, newImage);
      })
      .catch(() => {
        const index = this.images.indexOf(imageData);
        this.images.splice(index, 1);
      });
  }
}

async function uploadImage(imageData) {
  // create request object
  const reqBody = {
    crop_image: imageData.file,
    original_image: imageData.original_file,
    crop_data: imageData.cropParams,
    ordinal: imageData.ordinal || imageData.index + 1 || this.images.length + 1,
    extra_info: imageData.extra_info || {},
  };

  // use the image service to upload the image
  const resp = await ImageService.uploadImage(reqBody);

  const newImageData = {
    crop_url: resp.data.url,
    original_url: resp.data.original_url,
    id: resp.data.id,
    crop_params: imageData.cropParams,
    ordinal: imageData.ordinal,
  };

  const newImage = ImageService.createImageFromData(newImageData);

  return newImage;
}

async function updateImage(imageData) {
  // create request to the update image endpoint
  const reqBody = {
    image: imageData.file,
    crop_data: imageData.cropParams,
    id: imageData.id,
  };

  // use the image service to update the image
  const resp = await ImageService.updateImage(reqBody);

  const newImageData = {
    crop_url: resp.data.url,
    original_url: resp.data.original_url,
    id: resp.data.id,
    crop_params: imageData.cropParams,
    ordinal: imageData.ordinal,
  };

  const newImage = ImageService.createImageFromData(newImageData);

  return newImage;
}
</script>

<style lang="scss" scoped>
.draggable-node {
  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 100%;
    z-index: 3;
    .loader-wrapper.loader-static {
      position: relative;
      top: 45%;
      left: -3%;
    }
  }
}
</style>
